import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import TheShiftMission from "./sections/TheShiftMission";
import OurGreenInitiative from "./sections/OurGreenInitiative";
import MeetTheExperts from "./sections/MeetTheExperts";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <TheShiftMission />
      <OurGreenInitiative />
      <MeetTheExperts />
      <Footer />
    </div>;
}